// Hosts that serve the non-production "trial" build. Detection is a positive/allowlist
// match: anything not in this list (production, local dev, previews) returns false, so
// the staging warning banner can never accidentally appear on production.
const STAGING_HOSTS = ['srbtest.ameeqcode.com'] as const

/**
 * True only when the app is served from a known staging host.
 *
 * Fails closed — production, localhost, and any unknown host return false. The host is
 * normalized (case-folded and stripped of a trailing FQDN dot) before the exact-match
 * lookup so a benign hostname variation can't slip the gate, while exact matching keeps
 * the warning from ever rendering on the production host.
 */
export function isStagingEnvironment(): boolean {
  const host = window.location.hostname.toLowerCase().replace(/\.$/, '')
  return (STAGING_HOSTS as readonly string[]).includes(host)
}
